import { useTranslation, Trans } from "react-i18next";
import { Text, Box } from "@chakra-ui/react";
import openExternal from "src/utils/openExternal";
import { getAppValue } from "src/utils/environment";
import ScrollBox from "src/atoms/ScrollBox/index";
import { H2, H3, BodyText } from "src/atoms/typography";
import BackButton from "src/components/BackButton";
import IconOnBackground from "src/components/IconOnBackground";
import { ReactComponent as MailIcon } from "./mail-outlined.svg";
import { ReactComponent as WrongIcon } from "./wrong.svg";
import { ReactComponent as ContactIcon } from "./edit.svg";

export default function Help({ flow }) {
  const { t } = useTranslation();
  return (
    <Box pt="47px" pb="24px" height="100%">
      <ScrollBox textAlign="center">
        <Box mx="auto" maxWidth="320px">
          <BackButton absolute onClick={flow.previous} />
          <H2 color="highEmphasis" mb="24px">
            {t("purchase.help.heading")}
          </H2>
          <IconOnBackground
            mx="auto"
            bg="primaryLight"
            fill="primaryLighter"
            icon={MailIcon}
          />
          <H3 color="highEmphasis" mt="8px">
            {t("purchase.help.noEmail.heading")}
          </H3>
          <BodyText mt="8px" color="mediumEmphasis">
            {t("purchase.help.noEmail.text")}
          </BodyText>

          <IconOnBackground
            mt="24px"
            mx="auto"
            bg="warningLight"
            fill="warningBase"
            icon={WrongIcon}
          />
          <H3 color="highEmphasis" mt="8px">
            {t("purchase.wrongCode")}
          </H3>
          <BodyText mt="8px" mb="24px" color="mediumEmphasis">
            {t("purchase.help.wrongCode.text")}
          </BodyText>

          <IconOnBackground
            mx="auto"
            bg={getAppValue({
              barkio: "tint3Light",
              bibino: "secondaryLight"
            })}
            fill={getAppValue({
              barkio: "tint3",
              bibino: "secondary"
            })}
            icon={ContactIcon}
          />
          <H3 color="highEmphasis" mt="8px">
            {t("purchase.help.contactUs.heading")}
          </H3>
          <BodyText mt="8px" color="mediumEmphasis">
            <Trans i18nKey="purchase.help.contactUs.text">
              If the issue persists, don&apos;t hesitate to contact our support
              team at
              <Text
                onClick={() => openExternal({ env: "EMAIL" })}
                as="span"
                cursor="pointer"
                textDecoration="underline"
                color="primary"
                _hover={{ color: "primaryLighter" }}
                _active={{ color: "primaryDarker" }}
              >
                support@barkio.com
              </Text>
              , we will help you.
            </Trans>
          </BodyText>
        </Box>
      </ScrollBox>
    </Box>
  );
}
